module.exports = __webpack_public_path__ + "static/media/Openvas-logo.9a6d1e2d.png";